import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import DfosFormPage from "../components/DfosFormPage";

const DfosForm = () => {
  return (
    <div>
      <MasterLayout>
        <DfosFormPage />
      </MasterLayout>
    </div>
  );
};

export default DfosForm;
